import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Text';
import Container from '../Container';
import Icon from '../Icon';
import EmptyButton from '../EmptyButton';
import { propStyles } from '../../styleHelper';
import Eye from './Eye';

const StyledInput = styled.input`
  font-size: ${props => props.theme.fontSize.normal};
  color: ${props => props.theme.text.normal};
  border: none;
  border-radius: 8px;
  font-family: ${props => props.theme.font.circular};
  padding: 10px;
  width: 100%;
  &::placeholder {
    color: ${props => props.theme.text.text200};
  }
  &:focus {
    outline: none;
  }
  ${propStyles}
`;

const FancyInput = forwardRef(
  (
    { label, icon, showClear, onClear, onKeyDown, type, required, ...props },
    ref
  ) => {
    const { value = '' } = props;

    const [passwordText, setPasswordText] = useState();
    const [focused, setFocused] = useState(false);

    const selectAutoSuggest = e => {
      const elm = document.querySelector('.lsCommonClientAutoSuggest');
      if (e.keyCode === 40 && elm) {
        e.preventDefault();
        elm.querySelector('button:first-child').focus();
      }
    };

    return (
      <Container>
        {label && (
          <Text lineHeight="1" color="text600" fontSize="16px" fontWeight="600">
            {label} {required && <Text color="#F16159"> *</Text>}
          </Text>
        )}
        <Container
          display="flex"
          flexDirection="row"
          alignItems="center"
          marginTop="8px"
          border="1px solid"
          borderColor={focused ? theme => theme.primary.normal : 'border400'}
          {...props}
        >
          <Container>{icon}</Container>
          <Container flex="1">
            <StyledInput
              type={passwordText ? 'text' : type}
              ref={ref}
              onKeyDown={e => {
                onKeyDown(e);
                selectAutoSuggest(e);
              }}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              {...props}
            />
          </Container>
          {type === 'password' ? (
            <EmptyButton
              onClick={() => setPasswordText(!passwordText)}
              type="button"
            >
              <Eye fill={passwordText ? '#285aff' : '#4a4a4a'} />
            </EmptyButton>
          ) : null}
          {showClear && value.length && type !== 'password' ? (
            <EmptyButton tabIndex="-1" onClick={onClear} type="button">
              <Icon
                iconColor="normal"
                iconSize="normal"
                className="ls-icon icon-generalxlarge"
              />
            </EmptyButton>
          ) : null}
        </Container>
      </Container>
    );
  }
);

FancyInput.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.node,
  showClear: PropTypes.bool,
  value: PropTypes.string,
  onClear: PropTypes.func,
  onKeyDown: PropTypes.func,
  required: PropTypes.bool,
};

FancyInput.defaultProps = {
  type: 'text',
  label: null,
  icon: null,
  showClear: true,
  value: undefined,
  required: false,
  onClear: () => {},
  onKeyDown: () => {},
};

export default FancyInput;
